import React from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  className?: string;
};

const AdminHomeButton: React.FC<Props> = ({ className }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate("/")}
      className={
        className ??
        "fixed top-4 right-4 z-50 bg-white/85 hover:bg-white text-heading border border-white/40 font-semibold px-4 py-2 rounded-2xl shadow-soft hover:shadow-card transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brandOrange focus:ring-offset-2"
      }
    >
      Home
    </button>
  );
};

export default AdminHomeButton;

